/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { Link } from "@i18n/next";
import {
  ArrowLeftIcon,
  cssMediaQueryMinWidthTablet,
  IconButton,
  numericPercentages,
  numericPixels,
  PanelContentContainer,
  spacing,
} from "@packages/ui";

type SettingsPaneProps = {
  title?: string;
  children?: React.ReactNode;
  containerCSS?: Interpolation;
};

const centeredStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
};

const containerStyles: Interpolation = {
  display: "flex",
  flexDirection: "column",
  maxWidth: numericPixels[600],
  width: numericPercentages[100],
  padding: `${spacing.m} 0`,
  [cssMediaQueryMinWidthTablet]: {
    padding: spacing.xl,
  },
};

const backButtonStyles: Interpolation = {
  display: "block",
  [cssMediaQueryMinWidthTablet]: {
    display: "none",
  },
};

export const SettingsPane = ({
  title,
  children,
  containerCSS,
}: SettingsPaneProps) => {
  return (
    <PanelContentContainer
      title={title}
      titleActionLeft={
        <IconButton
          asChild
          icon={<ArrowLeftIcon />}
          variant="secondary"
          css={backButtonStyles}
        >
          <Link href={"/settings"} />
        </IconButton>
      }
    >
      <div css={centeredStyles}>
        <section css={[containerStyles, containerCSS]}>{children}</section>
      </div>
    </PanelContentContainer>
  );
};
